import {
  Route,
  createBrowserRouter,
  RouterProvider,
  createRoutesFromElements,
  Navigate,
} from 'react-router-dom';
import ProtectedRoute from './Components/ProtectedRoute';
import Layout from './Components/Layout/Layout';
import Login from './Pages/Login';
import SelectView from './Pages/SelectView';
import Inventory from './Pages/Seller/Inventory';
import Orders from './Pages/Seller/Orders';
import Analytics from './Pages/Seller/Analytics';
import Catalog from './Pages/Seller/Catalog';
import Dashboard from './Pages/Seller/Dashboard';
import SellerPriceLog from './features/Seller/SellerPriceLog';
import BrandMarginView from './features/Seller/BrandMarginView';
import EditCatalogProduct from './Pages/Seller/EditCatalogProduct';
import SellerNotifications from './Pages/Seller/SellerNotifications';
import LatestOrders from './features/Seller/Order/LatestOrders';
import DashboardAnalytics from './Pages/Brands/Dashboard/DashboardAnalytics';
import ProductList from './Pages/Brands/Product/ProductList';
import AddnewProduct from './Pages/Brands/Product/AddnewProduct';
import ProductDetails from './Pages/Brands/Product/ProductDetails';
import EditProduct from './Pages/Brands/Product/EditProduct';
import Distributor from './Pages/Brands/Distributor/Distributor';
import History from './Pages/Brands/History/History';
import Home from './Pages/Home';
import Unauthorized from './Pages/Unauthorized';
import { ToastContainer } from 'react-toastify';
import './styles/_main.scss';
import './styles/_themes.scss';
import DistributorSellers from './Pages/Brands/Distributor/DistributorSellers';
import HistoryPage from './Pages/Brands/History/HistoryPage';
import CatalogDetails from './features/Seller/Catalog/CatalogDetails';
import BrandCatalog from './Pages/Seller/BrandCatalog/BrandCatalog';
import SignUp from './Pages/SignUp';
import AddProductToCatalog from './Pages/Seller/SellerProduct/AddProductToCatalog';
import OrderDetailsPage from './Pages/Seller/SellerProduct/OrderDetailsPage';
import BrandProfile from './Pages/Brands/BrandProfile';
import SellerProfile from './Pages/Seller/SellerProduct/SellerProfile';
import ApplyForBrands from './Pages/Seller/ApplyForBrands';
import ChangePassword from './Components/Ui/ChangePassword';
import ForgotPassword from './Components/Ui/ForgotPassword';
import ResetPassword from './Components/Ui/ResetPassword';

const router = createBrowserRouter(
  createRoutesFromElements(
    <>
      <Route path="/" element={<Layout />}>
        <Route index element={<Home />} />

        {/* Brand Routes */}
        <Route element={<ProtectedRoute allowedRoles={['brand']} requiredViewType="brand" />}>
          <Route path="brand">
            <Route index element={<Navigate to="products" replace />} />

            <Route path="dashboard" element={<DashboardAnalytics />} />
            <Route path="products" element={<ProductList />} />
            <Route path="products/new" element={<AddnewProduct />} />
            <Route path="products/:id" element={<ProductDetails />} />
            <Route path="products/edit/:id" element={<EditProduct />} />
            <Route path="sellers">
              <Route index element={<Distributor />} />
              <Route path="distributor/:id" element={<DistributorSellers />} />
            </Route>
            <Route path="history" element={<HistoryPage />} />
            <Route path="products/:id/history" element={<History />} />
            <Route path="/brand/profile" element={<BrandProfile />} />
          </Route>
        </Route>

        {/* Seller Routes */}
        <Route element={<ProtectedRoute allowedRoles={['seller']} requiredViewType="seller" />}>
          <Route path="seller">
            {/* Default index → goes to brand-catalog */}
            <Route index element={<Navigate to="brand-catalog" replace />} />

            <Route path="inventory" element={<Inventory />} />
            <Route path="orders" element={<Orders />} />
            <Route path="orders/details" element={<OrderDetailsPage />} />
            <Route path="brand-catalog" element={<BrandCatalog />} />
            <Route path="catalogs/new/base/:id" element={<AddProductToCatalog />} />
            <Route path="catalog/edit/:id" element={<EditCatalogProduct />} />
            <Route path="catalog" element={<Catalog />} />
            <Route path="catalog/:id" element={<CatalogDetails />} />
            <Route path="price-log" element={<SellerPriceLog />} />
            <Route path="analytics" element={<Analytics />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="brand-margin" element={<BrandMarginView />} />
            <Route path="nortification" element={<SellerNotifications />} />
            <Route path="latest-orders" element={<LatestOrders />} />
            <Route path="/seller/profile" element={<SellerProfile />} />
            <Route path="apply-for-brands" element={<ApplyForBrands />} />
          </Route>
        </Route>
      </Route>

      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<SignUp />} />
      <Route path="/select-view" element={<SelectView />} />
      <Route path="/unauthorized" element={<Unauthorized />} />
      <Route path="/change-password" element={<ChangePassword />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password/:token" element={<ResetPassword />} />
    </>,
  ),
  {
    future: {
      v7_startTransition: true,
      v7_relativeSplatPath: true,
    },
  },
);

function App() {
  return (
    <>
      <RouterProvider router={router} />
      <ToastContainer position="top-right" className="mt-12" autoClose={2000} />
    </>
  );
}

export default App;
